"use client";

import { useColorMode } from "@chakra-ui/react";
import { useEffect } from "react";
import { useDashboardTheme } from "@/components/dashboard/DashboardThemeProvider";

/**
 * Keeps Chakra colorMode aligned with the visual dashboard theme.
 */
export function DashboardChakraColorModeSync() {
  const { setColorMode } = useColorMode();
  const { mode } = useDashboardTheme();

  useEffect(() => {
    setColorMode(mode);
  }, [mode, setColorMode]);

  return null;
}
